import { spaceUnit } from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";

export const stepSize = 20 * spaceUnit;
